import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const NotLoggedInModal = (props) => {
	const { isOpen, toggle, googleAuthUrl } = props;
	
	return (
		<Modal isOpen={isOpen} toggle={toggle} className="logoutModal">
			<ModalHeader toggle={toggle}>You Are Not Logged In!</ModalHeader>
			<ModalBody>
					You are not logged in and your answer will not be recorded. Quickly log in using the button below and then re-submit your answer.
			</ModalBody>
			<ModalFooter>
				<Button color="secondary" onClick={toggle}>Cancel</Button>{' '}
				<Button color="success" href={googleAuthUrl}>Log In</Button>
			</ModalFooter>
		</Modal>
	);
}

export default NotLoggedInModal;